import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../plots-data/plots-data.css";
import { useNavigate } from "react-router-dom";


const HomeReservation = ({ selectedPlotData }) => {
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    plotNo: "",
    areaSqFt: "",
    totalCost: "",
    facing: "",
  });

    const navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (selectedPlotData) {
      setFormData((prev) => ({
        ...prev,
        plotNo: selectedPlotData.plotNo?.toString() || "",
        areaSqFt: selectedPlotData.areaSqFt?.toString() || "",
        totalCost: selectedPlotData.totalCost?.toString() || "",
        facing: selectedPlotData.facing?.toString() || "",
      }));
    }
  }, [selectedPlotData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "name",
      "phoneNumber",
      "plotNo",
      "areaSqFt",
      "totalCost",
      "facing",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field].trim()) {
        newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required`;
      }
    });

    if (formData.name.trim() && formData.name.length < 2) {
      newErrors.name = "Name must be at least 2 characters";
    }

    if (formData.phoneNumber && !/^\d{10}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Phone number must be 10 digits";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validateForm()) {
    toast.error("Please fill all fields correctly.");
    return;
  }

  const payload = {
    type: "plots",
    project: "Ponbhoomi",
    sqft: formData.areaSqFt,
    name: formData.name,
    mobile: formData.phoneNumber,
    facing: formData.facing,
    plot_no: formData.plotNo,
    total_cost: formData.totalCost,
  };

  try {
    const response = await fetch("https://cms.gphomes.in/api/enquiry-form", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "gp-web-token": "sdswkhsADWRjfh9Thwn8rn6Mybd",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Response data:", data);
    toast.success("Form submitted successfully!");
    setSubmitted(true);
    setFormData({
      name: "",
      phoneNumber: "",
      plotNo: "",
      areaSqFt: "",
      totalCost: "",
      facing: "",
    });

    // ✅ Redirect after short delay to show THANK YOU
    setTimeout(() => {
      navigate("/Ponbhoomigp.gphomes/thank-you");
    }, 1500);
  } catch (error) {
    console.error("Error:", error);
    toast.error("Failed to submit form. Please try again.");
  }
};


  return (
    <section className="testimonials pt-5" id="reservation-sec">
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
      />
      <div
        className="background bg-img bg-fixed section-padding pb-0"
        style={{
          backgroundImage: `url(https://www.gphomes.in/static/media/videobg.fd443234030f853fbbd0.jpg)`,
        }}
        data-overlay-dark="3"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-5 mb-30 mt-30">
              <h3>ENQUIRE NOW</h3>
              <br />
              <h6>
                Interested in learning more? Our property experts are here to
                help! Reach out to us, and we'll get back to you with all the
                details soon.
              </h6>
              <div className="reservations mb-30">
                <div className="icon">
                  <span className="flaticon-call"></span>
                </div>
                <div className="text">
                  <p color-1>Contact Us</p>
                  <a className="color-1" href="tel:+919344481444">
                    9344481444
                  </a>
                </div>
              </div>

              <div className="reservations mb-30">
                <div className="icon">
                  <span className="flaticon-call"></span>
                </div>
                <div className="text">
                  <p color-1>Contact Us</p>
                  <a className="color-1" href="tel:+916384003003">
                    6384003003
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-5 offset-md-2">
              <div className="booking-box">
                <div className="head-box">
                  <h6>Booking Form</h6>
                  <h4>Drop in a line with your details.</h4>
                </div>
                <div className="booking-inner clearfix">
                  <form onSubmit={handleSubmit} className="form1 clearfix">
                    <div className="row">
                      {[
                        { label: "Name", name: "name", type: "text" },
                        {
                          label: "Phone Number",
                          name: "phoneNumber",
                          type: "text",
                        },
                        { label: "Plot No", name: "plotNo", type: "text" },
                        { label: "Area SqFt", name: "areaSqFt", type: "text" },
                        {
                          label: "Total Cost",
                          name: "totalCost",
                          type: "text",
                        },
                        { label: "Facing", name: "facing", type: "text" },
                      ].map(({ label, name, type }) => (
                        <div className="col-md-12" key={name}>
                          <div className="input1_wrapper">
                            <label>{label} *</label>
                            <div className="input1_inner">
                              <input
                                type={type}
                                className={`form-control ${
                                  errors[name] ? "is-invalid" : ""
                                }`}
                                
                                name={name}
                                value={formData[name]}
                                onChange={handleChange}
                                readOnly={
                                  !!selectedPlotData &&
                                  [
                                    "plotNo",
                                    "areaSqFt",
                                    "totalCost",
                                    "facing",
                                  ].includes(name)
                                }
                              />
                              {errors[name] && (
                                <div className="invalid-feedback">
                                  {errors[name]}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}

                      <div className="col-md-12">
                        <button
                          type="submit"
                          className="btn-form1-submit mt-15"
                          disabled={submitted}
                        >
                          {submitted ? "THANK YOU!" : "SUBMIT"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeReservation;
